module.exports = ".info-header {\n  color: red;\n  font-weight: bold;\n  font-size: 3em;\n  text-align: center; }\n\n.info-row-label {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/dev/dev.component.scss
// module id = ./src/app/+app-custom/components/dev/dev.component.scss
// module chunks = main